import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqs = [
    {
      question: 'What types of civil disputes do you handle?',
      answer: 'We handle a wide range of civil disputes including contract breaches, property disputes, commercial litigation, debt recovery, partnership disputes, and appellate proceedings. Our experienced team provides comprehensive representation for both plaintiffs and defendants.'
    },
    {
      question: 'How long does civil litigation typically take?',
      answer: 'The duration of civil litigation varies depending on case complexity, court schedules, and whether parties reach settlement. Simple cases may resolve in 6-12 months, while complex commercial disputes can take 2-3 years. We work efficiently to minimize delays.'
    },
    {
      question: 'What are the costs associated with civil litigation?',
      answer: 'Litigation costs include court fees, attorney fees, expert witness fees, and administrative expenses. We provide transparent fee structures and work with clients to develop cost-effective strategies, including exploring settlement options when appropriate.'
    },
    {
      question: 'Should I try to settle my case out of court?',
      answer: 'Settlement can be beneficial as it saves time, reduces costs, and provides certainty. However, the decision depends on the specific circumstances of your case. We analyze each situation and advise whether settlement or trial is in your best interest.'
    },
    {
      question: 'What is the difference between mediation and arbitration?',
      answer: 'Mediation involves a neutral third party helping parties reach a mutually acceptable agreement, while arbitration involves a neutral arbitrator making a binding decision. Both are alternative dispute resolution methods that can be faster and less expensive than court litigation.'
    },
    {
      question: 'How do I know if I have a strong case?',
      answer: 'Case strength depends on factors like evidence quality, legal precedents, witness availability, and applicable laws. We conduct thorough case evaluations to assess your chances of success and provide honest assessments of your legal position.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-surface/10 to-primary/5">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-text-secondary">
            Common questions about civil litigation and dispute resolution
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-border-light overflow-hidden shadow-sm"
            >
              <button
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-surface/20 transition-colors duration-200"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-lg font-heading font-semibold text-text-primary pr-4">
                  {faq.question}
                </h3>
                <Icon
                  name={openFAQ === index ? 'ChevronUp' : 'ChevronDown'}
                  size={20}
                  className="text-text-secondary flex-shrink-0"
                />
              </button>
              {openFAQ === index && (
                <div className="px-8 pb-6">
                  <p className="text-text-secondary leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-text-secondary mb-4">
            Have more questions about civil litigation?
          </p>
          <button
            onClick={() => {
              const message = encodeURIComponent("Hello, I have questions about civil litigation services.");
              window.open(`https://wa.me/254721320787?text=${message}`, '_blank');
            }}
            className="inline-flex items-center space-x-2 bg-primary text-white px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors duration-200"
          >
            <Icon name="MessageCircle" size={20} />
            <span>Ask Our Experts</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;